import { useState } from "react";
import { Link } from "react-router-dom";

const NEWSLETTER_URL = "https://readdy.ai/api/form/d7cj6jc5q56ra7tuf880";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch(NEWSLETTER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-map-pin-2-fill text-amber-400 text-lg"></i>
              </div>
              <span className="text-white font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>
                Yerel Bilgi
              </span>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">
              Türkiye'nin gizli kalmış güzelliklerini, en iyi restoranlarını ve yerel sırlarını keşfedin.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-instagram-line", "ri-twitter-x-line", "ri-youtube-line"].map((icon) => (
                <a key={icon} href="#" rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-800 hover:bg-amber-500 transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Keşfet</h4>
            <ul className="space-y-2">
              {[
                { label: "Gezilecek Yerler", path: "/places" },
                { label: "En İyi Restoranlar", path: "/restoranlar" },
                { label: "Konaklama", path: "/accommodations" },
                { label: "Makaleler & Rehberler", path: "/articles" },
                { label: "Duyurular & Haberler", path: "/duyurular" },
                { label: "Karadeniz Yayla Rehberi", path: "/guides/karadeniz-yayla-rehberi" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-stone-400 hover:text-amber-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* City FAQ Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Şehir Rehberleri</h4>
            <ul className="space-y-2">
              {[
                { label: "İstanbul SSS", path: "/istanbul-sss" },
                { label: "Kapadokya SSS", path: "/kapadokya-sss" },
                { label: "Antalya SSS", path: "/antalya-sss" },
                { label: "İzmir SSS", path: "/izmir-sss" },
                { label: "Mardin SSS", path: "/mardin-sss" },
                { label: "Trabzon SSS", path: "/trabzon-sss" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-stone-400 hover:text-amber-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-2">Bülten</h4>
            <p className="text-xs text-stone-400 mb-4">Yeni keşifler ve rehberler için abone olun.</p>
            {submitted ? (
              <div className="bg-amber-500/20 border border-amber-500/30 rounded-lg px-4 py-3 text-amber-400 text-sm">
                Teşekkürler! Bültene kaydoldunuz.
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-posta adresiniz"
                  required
                  className="bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-sm text-white placeholder-stone-500 focus:outline-none focus:border-amber-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold py-2 rounded-lg transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {loading ? "Kaydediliyor..." : "Abone Ol"}
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-stone-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-500">© 2026 Yerel Bilgi. Tüm hakları saklıdır.</p>
          <p className="text-xs text-stone-500">Türkiye'nin gizli güzelliklerini keşfedin.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
